import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _VerticalCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M9 21V10H4M15 21V10h6M12 3v18M9 6h6" }) }) });
}
const VerticalCustom = forwardRef(_VerticalCustom);
export { VerticalCustom };
